import $ from 'jquery';
(window as any).jQuery = $; // Assign to window.jQuery
(window as any).$ = $;      // Assign to window.$
import 'bootstrap';
import * as bootstrap from 'bootstrap';
(window as any).bootstrap = bootstrap; // expose Bootstrap for inline scripts that expect a global
import SparkMD5 from 'spark-md5';
(window as any).SparkMD5 = SparkMD5;
import '../apps/navbar/main';
import '../apps/locale_switcher/main';
import '../utils/bus.ts';
// Start the route-style cloud-sync bridge: it listens for `user:updated`
// (navbar / on_boarding emit this after a GetUser fetch) and pushes
// changes via UpdateUser whenever the customise-route-style screen
// persists. See utils/routeStyleSettingsCloudSync.ts for the boundary
// mappings.
import { init as initRouteStyleCloudSync } from '../utils/routeStyleSettingsCloudSync';
initRouteStyleCloudSync();
import Rails from 'rails-ujs'
import '../utils/images.d.ts';
import '../utils/window.d.ts';
import '../utils/analytics/analytics';
import '../utils/analytics/addToCart';
import '../utils/attribution/attributionCapture';
import '../utils/splide';
import '../apps/search/main';
import '../apps/review_prompt/main';
import '../utils/auth/logout_links';

Rails.start();

// Initialize Firebase auth sync if Firebase is configured
// This ensures Firebase auth state stays in sync with Rails session
if ((window as any).firebaseConfigs) {
  import('../utils/firebase/authSync').then(({ initAuthSync }) => {
    initAuthSync();
  }).catch((error) => {
    console.warn('Failed to initialize Firebase auth sync:', error);
    // Unblock anything waiting on auth if init fails
    import('../utils/firebase/authReady').then(({ signalAuthReady }) => signalAuthReady());
  });
} else {
  // No Firebase config — unblock auth-dependent code immediately
  import('../utils/firebase/authReady').then(({ signalAuthReady }) => signalAuthReady());
}
console.log("Hello from application.js on vite");

// DYNAMIC IMPORTING
// Only import comments if #new_review is in the viewport and visible
const $addReviewButton = document.getElementById('new_review');
if ($addReviewButton) {
  import('../apps/comments/main');
}

console.log('Hello World from Hiiker!');

// Attach event listener to the button
const giftButton = document.getElementById('giftCheckoutButton');
if (giftButton) {
  import('../apps/on_boarding/main');
  giftButton.addEventListener('click', function (e) {
    e.preventDefault();
    if (window.user == null) {
      window.onBoardingVue.launchFor(OnBoardingGoal.CreateAccountForPurchase, [AuthMethods.Email])
      return
    } else {
      window.location.href = window.giftCheckoutUrl;
    }
  });
}
